export { P as Panel, W as Widget } from './index-215be08a.js';
import 'react';
import '@uploadcare/client-suspense';
import 'react-fast-compare';